// extracted by mini-css-extract-plugin
export default {"info":"Header-info_QPfxg","root":"Header-root_S91gj","title":"Header-title_dOrpv","nav":"Header-nav_rWygB","addDomainBtn":"Header-addDomainBtn_N6YI9"};